import EmbedSettings from 'app/developer-v3/pages/embed/settings/EmbedSettings';
import Credentials from 'app/developer-v3/pages/embed/settings/Credentials';
import Domains from 'app/developer-v3/pages/embed/settings/Domains';
import Redirects from 'app/developer-v3/pages/embed/settings/Redirects';

import { getAppUrl } from 'app/developer-v3/utils/url';

export default {
  component: EmbedSettings,
  routes: {
    '.': {
      onEnter({ router, routeTo }) {
        routeTo(`${router.next.url}/credentials`);
      },
    },
    // TODO: Remove this redirect when there is no or little traffic.
    // This redirect exists to avoid ../client from being broken since
    // ../client is a predecessor of ../credentials
    client: {
      onEnter({ routeTo, router }) {
        routeTo(
          `${getAppUrl(router.next.params.id)}/embed-settings/credentials`
        );
      },
    },
    credentials: Credentials,
    domains: Domains,
    redirects: Redirects,
  },
};
